export default function PHP_symlink() {
  return (
    <div>
      <h1>PHP_symlink</h1>
    </div>
  );
}
